module.exports = __webpack_public_path__ + "src/assets/games/60/2.png";